// @flow
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'constants/routes';
import { useSelector } from 'react-redux';
import { Content } from 'components';
import Auth from '../Auth';
import CardTablePage from '../../pages/CardTable';
import ResultsTable from '../../pages/ResultsTable';
import TrainingGamePage from '../../pages/TrainingGame';
import Postflop from '../../pages/Postflop';
import PostflopResults from '../../pages/PostflopResults';
import ProtectedRoute from '../ProtectedRoute';
import Profile from '../../pages/Profile';
import FAQ from '../../pages/FAQ';
import ResultsFAQ from '../../pages/ResultsFAQ';
import PreflopFAQ from '../../pages/PreflopFAQ';
import TrainingFAQ from 'pages/TrainingFAQ';
import TermAndConditions from '../../pages/TermAndConditions';
import Privacy from '../../pages/Privacy';
import Payments from '../../pages/Payments';
import Partners from '../../pages/Partners/Partners';
import Articles from '../../pages/Articles/articles';
import Handtips from '../../pages/Articles/Articles/handtips';
import BGsuits from '../../pages/Articles/Articles/BGsuits';
import threeArticle from '../../pages/Articles/Articles/threeArticle';
import BGsuitsPlo5 from 'pages/Articles/Articles/BGsuitsPlo5';
import HandtipsPlo5 from 'pages/Articles/Articles/handtipsPlo5';

const Routes = () => {
  const isToken = useSelector((state) => state.auth.isAuthenticated);
  return (
    <Switch>
      <Route
        path={routes.auth.root}
        render={() => (isToken ? <Redirect exact to={routes.app.profile.root} />
          : <Auth />)}
      />
      <Content>
        <Switch>
          <Route exact path={routes.app.root}>
            <Redirect to={routes.app.combinationTable.root} />
          </Route>
          <Route exact path={routes.app.PreflopFAQ.root} component={PreflopFAQ} />
          <Route exact path={routes.app.trainingFaq.root} component={TrainingFAQ} />
          <Route exact path={routes.app.FAQ.root} component={FAQ} />
          <Route exact path={routes.app.resultsFAQ.root} component={ResultsFAQ} />
          <Route exact path={routes.app.termAndConditions.root} component={TermAndConditions} />
          <Route exact path={routes.app.privacy.root} component={Privacy} />
          <ProtectedRoute exact path={routes.app.profile.root} component={Profile} />
          <ProtectedRoute exact path={routes.app.combinationTable.root} component={CardTablePage} />
          <ProtectedRoute exact path={routes.app.resultsTable.root} component={ResultsTable} />
          <ProtectedRoute exact path={routes.app.trainingGame.root} component={TrainingGamePage} />
          <ProtectedRoute exact path={routes.app.postflop.root} component={Postflop} />
          <ProtectedRoute
            exact
            path={routes.app.postflopResults.root}
            component={PostflopResults}
          />
          <Route exact path={routes.app.articles.root} component={Articles} />
          <Route exact path={routes.app.articles.tips.root} component={Handtips} />
          <Route exact path={routes.app.articles.suit.root} component={BGsuits} />
          <Route exact path={routes.app.articles.threeArticle.root} component={threeArticle} />
          <Route exact path={routes.app.articles.goodbadsuitplo5.root} component={BGsuitsPlo5} />
          <Route
            exact
            path={routes.app.articles.singledoublesuitplo5.root}
            component={HandtipsPlo5}
          />
          <Route exact path={routes.app.partners.root} component={Partners} />
          <ProtectedRoute path={routes.app.payments.root} component={Payments} />
          <Redirect exact to={routes.app.combinationTable.root} />
        </Switch>
      </Content>
    </Switch>
  );
};

export default Routes;
